const LOCAL_QA_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export const isLocalReportQaHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) => LOCAL_QA_HOSTS.has(String(hostname || "").toLowerCase());

export const isLocalDapPreview = (
  searchParams,
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) =>
  isLocalReportQaHost(hostname) &&
  ["1", "true"].includes(
    String(searchParams?.get?.("dapPreview") || "").toLowerCase(),
  );
